export function getPageMeta({ pageTitle, pageDescription, pageURL, pageImg }) {
  return {
    title: pageTitle,
    titleTemplate: '%s | Chinchilla Essentials',
    meta: [
      { name: 'description', content: pageDescription },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: pageTitle },
      { property: 'og:description', content: pageDescription },
      { property: 'og:url', content: pageURL },
      { property: 'og:image', content: pageImg },
      { property: 'twitter:card', content: 'summary_large_image' },
      { property: 'twitter:site', content: '@chinessentials' },
      { property: 'twitter:title', content: pageTitle },
      { property: 'twitter:description', content: pageDescription },
      { property: 'twitter:image', content: pageImg }
    ]
  }
}
